import React, { useCallback } from 'react';
import NodeBranch, { NodeWithMaterial, SelectionState } from './NodeBranch';
import List from '@pelckmans/elementis/components/list';
import { ModuleContainingUserMaterial } from '../api';
import { useTranslation } from 'react-i18next';

type Props = {
  nodes: NodeWithMaterial[];
  selection: Record<string, SelectionState>;
  onSelectionChange: (nodeId: string, rowId: string) => void;
  selectedSuperModule: ModuleContainingUserMaterial;
};

export default function NodeTree({ nodes, onSelectionChange, selection, selectedSuperModule }: Props) {
  const { t } = useTranslation();
  const renderBranches = useCallback(
    (nodesToRender: NodeWithMaterial[], level: number = 0): JSX.Element[] =>
      nodesToRender.map(node => {
        if (node.id === 'general') {
          node.image = selectedSuperModule?.image;
          node.title = node.id === 'general' ? t('TOC_GENERAL') : node.title;
        }
        return (
          <NodeBranch
            key={node.id === 'general' ? `${node.id}-${selectedSuperModule?.id}` : node.id}
            node={node}
            level={level}
            renderBranches={renderBranches}
            onSelectionChange={onSelectionChange}
            selection={selection}
          />
        );
      }),
    [onSelectionChange, selectedSuperModule?.id, selectedSuperModule?.image, selection, t],
  );

  return (
    <List className="user-material-by-node" aria-label="Material node list">
      {renderBranches(nodes)}
    </List>
  );
}
